import { render, staticRenderFns } from "./ResourceCardSimple.vue?vue&type=template&id=578615d2"
import script from "./ResourceCardSimple.vue?vue&type=script&lang=js"
export * from "./ResourceCardSimple.vue?vue&type=script&lang=js"
import style0 from "./ResourceCardSimple.vue?vue&type=style&index=0&id=578615d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports